var _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _radialGradient2, _radialGradient3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLgWebosNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-2.8000000000000007 0 622.9 123.2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2500,
    height: 492,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 59.114,
    cy: 59.914,
    gradientUnits: "userSpaceOnUse",
    r: 64.282
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c22043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c22043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#c02042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#b91f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#ae1e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#a01c33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b1b31"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(1 0 0 -1 0 126.148)",
    gradientUnits: "userSpaceOnUse",
    x1: 36.363,
    x2: 68.853,
    y1: 118.196,
    y2: 28.93
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f18996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#dd5f70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#ce3d55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#c52848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#c22043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c22043"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(1 0 0 -1 0 126.148)",
    gradientUnits: "userSpaceOnUse",
    x1: 20.489,
    x2: 95.025,
    y1: 96.137,
    y2: 21.601
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce435d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#ba354f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#a82944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#9b203c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#941b37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#921936"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientTransform: "matrix(1 0 0 -1 0 126.148)",
    gradientUnits: "userSpaceOnUse",
    x1: 63.416,
    x2: 64.788,
    y1: 67.105,
    y2: 67.105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4bdc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#a9b3b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#646a71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#3f464e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343b42"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4bbc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#959ca2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#565d62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#363d42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b3337"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientTransform: "matrix(1 0 0 -1 0 126.148)",
    gradientUnits: "userSpaceOnUse",
    x1: 75.664,
    x2: 76.873,
    xlinkHref: "#a",
    y1: 40.005,
    y2: 40.005
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientTransform: "scale(11.459) rotate(45 -166.893 1257.52)",
    gradientUnits: "userSpaceOnUse",
    x1: -933.609,
    x2: -932.208,
    y1: 250.308,
    y2: 250.308
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#acbcc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272b31"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientTransform: "scale(75.1015) rotate(45 -155.48 1351.815)",
    gradientUnits: "userSpaceOnUse",
    x1: -1000.958,
    x2: -999.557,
    y1: 286.084,
    y2: 286.084
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4bdc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f464e"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientTransform: "rotate(180 -34588.66 9737.986) scale(67.4051)",
    gradientUnits: "userSpaceOnUse",
    x1: -1027.906,
    x2: -1026.503,
    y1: 288.026,
    y2: 288.026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4bdc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49535b"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientTransform: "matrix(1 0 0 -1 0 126.148)",
    gradientUnits: "userSpaceOnUse",
    x1: 63.48,
    x2: 64.667,
    xlinkHref: "#a",
    y1: 113.687,
    y2: 113.687
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 330.82,
    cy: 397.374,
    gradientTransform: "matrix(.6971 0 0 -.6971 -189.86 316.744)",
    gradientUnits: "userSpaceOnUse",
    r: 113.067
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#fcfcfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f1f4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#e0e6e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#c7d2d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0cdd3"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 328.037,
    cy: 398.159,
    gradientTransform: "matrix(.6971 0 0 -.6971 -189.86 316.744)",
    gradientUnits: "userSpaceOnUse",
    r: 16.506
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#fcfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#f2f5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#e0e7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0dbe0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.6 101.6h33.7V86h-38.1V21.9h-18.4v79.7zM247.8 71.2h15v13.9c-2.8 1.1-8.2 2.1-13.3 2.1-16.6 0-22.1-8.4-22.1-25.5 0-16.3 5.3-25.9 21.8-25.9 9.2 0 14.5 2.9 18.8 8.4l11.4-10.5c-7-10-19.2-13-30.6-13-25.8 0-39.3 14.1-39.3 40.9 0 26.7 12.2 41.2 39.2 41.2 12.4 0 24.5-3.2 31-7.8V56.3h-31.9z",
    fill: "#5a6870"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M374.1 47.2h2.1l-17 53.3h-2.7l-16.6-51.3h-.2L323 100.5h-2.9l-16.6-53.4h2.1l15.9 51.3h.2l16.5-51.3h3.2l16.4 51.3h.2zM380.1 74.2c.2 14.3 5.9 25.4 21.1 25.4 11 0 19.1-6.1 20.9-17.6h2.1c-1.5 12.2-10.6 19.7-22.7 19.7-16.5.2-23.4-12-23.4-27.9 0-17.8 11.3-27.9 23.4-27.9 16.6 0 24 13.7 23.4 28.3h-44.8zm42.5-2c.1-13.1-7.3-24.2-21.1-24.2-11.5 0-20.8 9.2-21.5 24.2zM436.4 83.6c2.7 9.1 9.5 16.1 20.3 16.1 13.8 0 20.7-12 20.7-25.7 0-12.4-6-25.9-20.7-25.9-13 0-21.6 9.4-21.6 25.9v.5H433V26.4h2.1v35.7h.2c2.5-9.7 10.1-16.2 21.4-16.2 14.7 0 22.7 13.1 22.7 28 0 16.1-8.6 27.8-22.7 27.8-10.9 0-19.8-7.6-22.4-18.2h.1",
    fill: "#7c7b7b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M522.6 24.6c24.5 0 37.7 17.7 37.7 38.8s-13.2 38.8-37.7 38.8-37.7-17.7-37.7-38.8c0-21 13.2-38.8 37.7-38.8zm0 75.6c22 0 35.2-15.4 35.4-36.7-.2-21.4-13.4-36.7-35.4-36.7s-35.2 15.4-35.4 36.7c.2 21.3 13.4 36.7 35.4 36.7zM616.5 47.2c-.5-15.2-11-20.4-24.8-20.4-10.8 0-23.9 3.7-23.9 17 0 13.4 13.2 14.9 26.3 18 14.2 3.5 26 5.2 26 20.7 0 14-13.9 19.9-26.9 19.9-17.3 0-30.1-7.7-29.8-26.4h2.1c0 17.7 11.4 24.3 27.6 24.3 12 0 24.8-5.2 24.8-18 0-14.9-14.9-16.2-26.7-19-12.4-2.8-25.6-5-25.6-19.5 0-14.7 13.8-19.1 26-19.1 14.9 0 26.1 5.9 26.9 22.5z",
    fill: "#c2064c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 0C27.6 0 0 27.6 0 61.6s27.6 61.6 61.5 61.6 61.4-27.3 61.7-61.1v-1C122.9 27.3 95.5 0 61.5 0z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9 19.9c-20.6 20.6-22.7 51.9-4.6 70s49.4 16 70-4.6 22.7-52 4.6-70.1C81.7 7 70.7 3 59.1 3c-13.6 0-28 5.7-39.2 16.9",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4 89.2l1.5-.9v-52l-.4-.6.4-.1v-.1h.3l4.6-1.6.8 1.4s.1.1.1.4l-.1 47.4h11.2l.9 1.4c.1.1.1.2.1.6v4.8c0 .3-.2.4-.3.4H60.4c-.4 0-.8-.2-.9-.2zM114 58.7H75.9v6.1l.9 1.3s.1.1.3.1h31.8c-1.6 24.1-22 43-46.3 43-12.4 0-24-4.8-32.8-13.5-8.6-8.7-13.4-20.2-13.4-32.6 0-12.3 4.6-24.1 13.3-32.8 8.8-8.7 19.9-13.3 33.1-13.5h2.8c.2 0 .3 0 .3-.4v-5c0-.4-.1-.5-.1-.5l-1.1-1.4-2.5.4-1.3.4c-28.9 0-50.6 24.2-50.6 53 0 13.9 5.5 27.1 15.4 36.9 9.9 9.9 23 14.9 37 14.9 14.1 0 27.3-5.3 37.2-15.2s15.4-23 15.4-36.9v-3zM42.7 34.6c-4.6 0-8.3 3.7-8.3 8.2s3.7 8.2 8.3 8.2 8.3-3.7 8.3-8.2-3.7-8.2-8.3-8.2z",
    fill: "url(#d)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7 88l-1.3 1.2h18.5L75.7 88z",
    fill: "#646e78"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7 84.3l1.2-1.2H64.8l-1.5 1.2z",
    fill: "#8599a2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8 33.9h-6.4l1.2 1.1h3.8z",
    fill: "#8f9ca3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 84.2l1.3-1.1V33.9L63.4 35z",
    fill: "url(#e)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7 84.3V88l1.2 1.2v-6.1z",
    fill: "url(#f)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4 33.9v55.3l1.3-1.2-.1-53z",
    fill: "#b4bdc3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1 41.9c0 3.8 3.1 6.8 6.9 6.8s6.8-3 6.8-6.8-3.1-6.8-6.8-6.8c-3.9 0-6.9 3-6.9 6.8z",
    fill: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9 41.9c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8zm14.9 0c0 3.8-3.1 6.8-6.8 6.8-3.8 0-6.9-3-6.9-6.8s3.1-6.8 6.9-6.8c3.7 0 6.8 3 6.8 6.8z",
    fill: "url(#g)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.8 63.5l-32-.1-1.2 1.3h31.9l.7-.7z",
    fill: "#525e62"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 59.8h35.7l1.3-1.3-38.2.1z",
    fill: "#919ea6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M113.8 61.6v-3l-1.2 1.2v1.8c0 13.6-5.3 26.4-14.9 36.1-9.6 9.6-22.4 14.9-36.1 14.9-13.6 0-26.4-5.3-36-14.9-9.7-9.7-15-22.5-15-36.1 0-28.1 22.9-51 50.9-51h2l1.2-1.2h-3.1C32.8 9.4 9.4 32.8 9.4 61.6c0 13.9 5.4 27.1 15.3 36.9 9.8 9.9 22.9 15.3 36.9 15.3s27.1-5.4 36.9-15.3 15.3-23 15.3-36.9z",
    fill: "url(#h)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 14.3h-2.6c-12.3.2-23.9 5.1-32.7 13.8-9 8.9-13.9 20.8-13.9 33.5 0 12.6 4.9 24.5 13.8 33.4 8.8 8.8 20.4 13.7 32.8 13.9h1.2c24.5-.3 44.9-19.6 46.6-44.1v-1.3l-.6.6-.6.7c-1.7 24.1-21.8 43-46 43-12.3 0-23.9-4.8-32.6-13.5S15.4 74 15.4 61.7s4.8-23.9 13.5-32.6 20.3-13.5 32.6-13.5h3.1z",
    fill: "url(#i)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 59.8l-1.2-1.2v6.1l1.2-1.3z",
    fill: "#b4bdc3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 14.3l1.2 1.2V9.4l-1.2 1.1z",
    fill: "url(#j)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1 34.6v54h17.2v-4.8H64V34.6zM60.9 10C32.8 10.3 10 33.3 10 61.6c0 13.8 5.4 26.7 15.1 36.5 9.7 9.7 22.7 15.1 36.4 15.1 13.8 0 26.8-5.4 36.5-15.1s15.1-22.7 15.1-36.5v-2.3H76.3V64h31.9v.7c-1.7 24.3-21.9 43.6-46.6 43.6-12.5 0-24.2-4.9-33-13.7s-13.7-20.5-13.7-33 4.9-24.2 13.7-33c8.9-8.8 20.6-13.7 33-13.7h2.5V10h-3.2z",
    fill: "url(#k)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 41.9c0 4.1 3.3 7.4 7.4 7.4s7.4-3.3 7.4-7.4-3.3-7.4-7.4-7.4-7.4 3.3-7.4 7.4",
    fill: "url(#l)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2 35.9c1.7 0 3.2.6 4.5 1.6-1.3-1.8-3.5-2.9-5.8-2.9-4.1 0-7.4 3.3-7.4 7.4 0 2.4 1.1 4.4 2.9 5.8-1-1.2-1.5-2.8-1.5-4.4-.1-4.2 3.2-7.5 7.3-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 10h-2.5C33.1 10 10 33.1 10 61.6c0 13.8 5.4 26.7 15.1 36.5l.9.9c-9.2-9.6-14.2-22.2-14.2-35.5C11.8 35 31.9 11.5 64 10M64 83.7s3.5 1 12.2 1v-1zM64 36.1v-1.5h-4.9v54s1.5-8.2 1.5-52.5zM113.1 59.2H76.3V64h1.3v-3.4c32.1 0 35.5-1.4 35.5-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2 64v.7c-1.6 24.3-21.9 43.6-46.6 43.6-12.5 0-24.2-4.9-33-13.7-5.8-5.7-9.8-12.8-11.9-20.4 5.5 20.1 23.9 34.7 45.8 34.7 23.5 0 45.1-18.4 46.4-44.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgWebosNew);
export default __webpack_public_path__ + "static/media/lg-webos-new.d7103cfe3445760373d893dc509e0a3f.svg";
export { ForwardRef as ReactComponent };